import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {useQuery} from '@tanstack/react-query'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {getMrtApiBasepath} from '../ssr/helpers'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import fetch from 'cross-fetch'

const useCustomPreferencesListQuery = () => {
    const {getTokenWhenReady} = useAccessToken()
    const {site, locale} = useMultiSite()
    const origin = useAppOrigin()

    async function getCustomPreferencesList() {
        try {
            const token = await getTokenWhenReady()
            const endpoint =
                origin + getMrtApiBasepath('/site-custom-preferences-list?siteId=' + site.id)

            const options = {
                headers: {
                    authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                method: 'GET',
                credentials: 'same-origin',
            }

            const response = await fetch(`${endpoint}`, options)
            const data = await response.json()

            return data
        } catch (e) {
            console.error('Error fetching custom preferences list:', e)
        }
    }

    return useQuery(['getCustomPreferencesList', locale.id], () => getCustomPreferencesList())
}

export default useCustomPreferencesListQuery
